export const headers = [
  { label: "File", key: "file" },
  { label: "Uploaded by", key: "uploadedBy" },
  { label: "Date Created", key: "dateCreated" },
  { label: "Summary", key: "summary" },
  { label: "Action", key: "action" }
];
